import { combineReducers } from '@reduxjs/toolkit';

import login from './login';
import homeData from './homeData';

const userReducer = combineReducers({
  login,
  homeData
});

export default userReducer;